import React, { Component } from "react";
import { connect } from "react-redux";
import CustomLink from "@/bit/components/components.custom-link";
import PropTypes from "prop-types";
import Spinner from "@/bit/components/components.spin";
import IconGlyph from "@/bit/components/components.icon-glyph";
import SupportAndSearch from "../../modals/support-search";
import { actions as headerActions } from "@/bit/reducers/reducers.header-reducer";
import SecureStorage from "@gcloud-npm/utils.secure.local-storage";
import getDeviceKindDependsOnViewPort from "@gcloud-npm/utils.common.get-device-kind-depends-on-viewport";
import { actions as modalActions } from "@/bit/reducers/reducers.modals-reducer";
import { getColor, COLOR_DICTIONARY } from "@gcloud-npm/utils.enums.colors";
import { Workers, WORKER_TYPES } from "@gcloud-npm/utils.worker-client";

const INPUT_ID = "inputsupportadnsearch";
let NO_RESULTS = false;
let QUERY = "";
let searchWorker = null;

export const checkIfSearchCompleted = (pagesSuggestedList) => {
  return pagesSuggestedList != null;
};

export const checkIfThereAreResults = ({
  pagesSuggestedList,
  querySuggestedInputs,
  checkPages = true,
  checkAt = true,
}) => {
  let res = false;
  if (checkPages) {
    const thereArePages =
      pagesSuggestedList &&
      ((pagesSuggestedList.regular && pagesSuggestedList.regular.length > 0) ||
        (pagesSuggestedList.services &&
          pagesSuggestedList.services.length > 0) ||
        (pagesSuggestedList.devices && pagesSuggestedList.devices.length > 0));
    res = thereArePages;
  }

  if (checkAt) {
    const checkATInputs =
      querySuggestedInputs && querySuggestedInputs.length > 0;
    res = res || checkATInputs;
  }
  return res;
};

export const handleAtRequest = ({ label, event, inputID, loading }) => {
  try {
    if (event) {
      event.preventDefault();
    }
    const inputValue = document.getElementById(inputID).value;
    let query = label || inputValue;

    if (NO_RESULTS && !loading) {
      query = encodeURIComponent(query);
      const originUrl = encodeURIComponent(window.location.href);

      const name = "searcher";
      const content = encodeURIComponent(`${QUERY}`);
      const variation = "asistente-virtual-no-results";
      debugger;
      const urlToRedirect = `https://www.movistar.es/atencion-cliente/sin-resultados/?name=${name}&content=${content}&variation=${variation}&origin-url=${originUrl}`;
      window.location.href = urlToRedirect;
    } else {
    }
  } catch (error) {
    console.error(error);
  }
};
class SearchInput extends Component {
  constructor(props) {
    super(props);
    this.resultModalOpen = false;
    this.state = {
      query: "",
      focus: false,
      loading: true,
      totalResults: 0,
    };
    this.ID = props.id ? props.id : INPUT_ID;
    NO_RESULTS = false;
  }

  setResultModalOpen = (flag) => {
    this.resultModalOpen = flag;
  };

  setUp = async () => {
    if (!searchWorker) {
      const { setSearcherInfo } = this.props;
      const PAGES_RESOURCENAME = "pages";
      const secureStorage = new SecureStorage();
      const device = getDeviceKindDependsOnViewPort();
      const persistedInfo = secureStorage.getItem("ts");
      searchWorker = await Workers.getWorker(WORKER_TYPES.SEARCH);
      const { pagesList, pagesNoResults, categoryOptions, suggestedInputs } =
        await searchWorker.getPagesAndHelpInfo({
          pageSegment: "particulares",
          device,
          persistedInfo,
        });
      setSearcherInfo({
        pagesList,
        suggestedInputs,
        categoryOptions,
        pagesNoResults,
      });
      await searchWorker.createSearchEngine({
        resources: pagesList, // lo que se indexa,
        resourceName: PAGES_RESOURCENAME,
      });
      this.setState({ loading: false });
      if (QUERY) {
        this.handleSearch(QUERY);
      }
    }
  };

  componentDidMount = () => {
    // Logica busqueda por parametro url
    const { ignoreParamDesktop, autoSetup } = this.props;
    const device = getDeviceKindDependsOnViewPort();
    if (device !== "MOBILE" || ignoreParamDesktop) {
      const urlParams = new URLSearchParams(window.location.search);
      const queryParam = this.sanitizeInput(urlParams.get("q"));
      const delayParam = urlParams.get("delay");
      if (queryParam) {
        this.setUp();
        this.typeText(queryParam, 0, this.convertToNumber(delayParam));
      }
    }

    if (autoSetup) {
      this.setUp()
    }
  
    
  };

  sanitizeInput = (input) => {
    if (input) {
      return input.replace(/[<>{}]/g, ""); // Remueve etiquetas HTML
    }
    return "";
  };

  convertToNumber = (str) => {
    if (str && !isNaN(str)) {
      return parseFloat(str);
    } else {
      return null;
    }
  };

  typeText = (queryParam, index, delay) => {
    if (index < queryParam.length) {
      this.setState((prevState) => ({
        query: prevState.query + queryParam[prevState.query.length],
      }));
      const finalDelay = delay || 1200;
      setTimeout(() => {
        this.typeText(queryParam, index + 1, delay);
      }, finalDelay / queryParam.length);
    } else this.handleInputChange({ target: { value: queryParam } });
  };

  onCloseHandler = () => {
    this.setResultModalOpen(false);
    this.handleClear({ withQueryReset: true });
  };

  openSearchModal = () => {
    this.setResultModalOpen(true);
    const { addModal } = this.props;
    addModal({
      id: "searcher",
      Element2Show: SupportAndSearch,
      modalProps: {
        disableModalAutofocus: true,
        contentPosition: "center--top",
        opacityLayoutColor: "blur",
        inSceneEffect: "fadeIn",
        contentInsideContainer: true,
        outSceneEffect: "fadeOut",
        closeAllOnClickOutside: true,
        closeByClickingOutside: true,
        createAnchor: false,
        onCloseHandler: this.onCloseHandler,
      },
      elementProps: {
        visibleInput: false,
      },
    });
  };

  handleSearch = async (query) => {
    const { setRelatedPages, onSearch, needOpenModalResults } = this.props;
    // buscamos por paginas
    // getRelatedPages(query);
    if (searchWorker) {
      this.setState({ loading: true });
      const { pagesList, categoriesMatched } = await searchWorker.performQuery({
        resourceName: "pages",
        query,
      });
      const totalResults =
        pagesList.regular.length +
        pagesList.services.length +
        pagesList.devices.length;

      NO_RESULTS = totalResults === 0;

      setRelatedPages({ pagesList, categoriesMatched, inputQuery: query });
      this.setState({
        loading: false,
        totalResults,
      });
    }

    // comunicamos a quien lo necesite
    if (onSearch) {
      onSearch(query);
    }
    // gestion de modal
    if (needOpenModalResults && !this.resultModalOpen) {
      this.openSearchModal();
    }
  };

  onInputClick = () => {
    this.setUp();
    this.setState({ focus: true });
  };
  onBlurClick = () => {
    const { addModal } = this.props;
    const { totalResults } = this.state;
    this.setState({ focus: false });
  };
  onBlurReset = () => {
    this.onBlurClick();
    this.focusResults();
  };

  blurResults = (e) => {
    if (e.key === "Tab" && e.shiftKey) {
      const input = document.getElementById("inputsupportadnsearch");
      if (input) input.focus();
    }
  };
 
  focusResults = () => {
    try {
      var results = document.querySelectorAll(
        ".SuggestedInput,.ResultsSection"
      );
      const divResults = results ? results[0] : null;
      const eResults = divResults
        ? divResults.querySelectorAll(".next-link")
        : null;
      if (eResults) {
        eResults[0].focus();
        eResults[0].removeEventListener("keydown", this.blurResults);
        eResults[0].addEventListener("keydown", this.blurResults);
      }
    } catch (e) {}
  };
  handleClear = ({ withQueryReset = true, withCloseModal = false }) => {
    const { resetSearcher, onSearch, addModal } = this.props;

    if (withQueryReset) {
      QUERY = "";
      this.setState({ query: "", totalResults: 0 });
    }
    if (onSearch) {
      onSearch("");
    }
    resetSearcher();
    if (withCloseModal) {
      addModal({ id: "" });
    }
  };

  handleInputChange = (event) => {
    const { loading } = this.state;
    const query = event.target.value;
    if (query && query.length > 1) {
      if (!loading) {
        this.handleSearch(event.target.value);
      }
    } else {
      this.handleClear({ withQueryReset: false });
    }
    QUERY = event.target.value;
    this.setState({ query: event.target.value });
  };

  render() {
    const { query, focus, loading, totalResults } = this.state;

    const { backButton, className, placeHolder, autoComplete } = this.props;
    return (
      <>
        <form
          className="form-searcher"
          id={`form-${this.ID}`}
          onSubmit={(event) => {
            handleAtRequest({ event, inputID: this.ID, loading });
          }}
        >
          <div
            className={`SearchInput${focus ? " focus" : ""}`}
            data-cy="Header search"
            role="search"
            aria-label="Buscador"
          >
            <button
              name="buscar"
              tabIndex={query && query.length > 0 ? "0" : "-1"}
              aria-label="Buscar"
              type="submit"
              className="search-input-button-cont"
            >
              {focus && loading ? (
                <Spinner
                  size="small"
                  operation="loading"
                  fillColor={getColor(COLOR_DICTIONARY.GREY_600)}
                  strokeColor={getColor(COLOR_DICTIONARY.GREY_600)}
                />
              ) : (
                <IconGlyph aspectRatio={1} color={COLOR_DICTIONARY.GREY_600} id="buscar-m" width={22} />
              )}
            </button>
            <input
              id={this.ID}
              className={`${className ? ` ${className} ` : ""} field`}
              type="search"
              name="searcher"
              value={query}
              onFocus={this.onInputClick}
              onClick={this.onInputClick}
              onBlur={this.onBlurClick}
              autoComplete={autoComplete}
              onChange={this.handleInputChange}
              placeholder={placeHolder}
              data-cy={`Header input search${className ? ` ${className}` : ""}`}
            />
            {totalResults > 0 && (
              <CustomLink
                className="visuallyhidden"
                type="button"
                ariaLabel="Ver resultados"
                onClick={this.focusResults}
              />
            )}
            {backButton && query && query.length > 0 && (
              <button
                className="clearButton"
                type="button"
                aria-label="Eliminar búsqueda"
                onBlur={this.onBlurReset}
                onClick={() =>
                  this.handleClear({
                    withQueryReset: true,
                    withCloseModal: true,
                  })
                }
              >
                <IconGlyph color={COLOR_DICTIONARY.GREY_700} id="cerrar-m" width={12} />
              </button>
            )}
            <div
              key={`${query}`}
              className="search-status"
              role="status"
              aria-live="polite"
            >
              Se han encontrado {totalResults} resultados, empleando el texto:{" "}
              {query}
            </div>
          </div>
          <style jsx>{`@import "styles/colors.scss";

.form-searcher {
  display: none;
  width: 100%;
  font-family: "Regular";
  .backbutton {
    margin-right: 1rem;
  }
  .SearchInput {
    max-width: 100%;
    width: 100%;
    padding: 0rem 1rem;
    height: auto;
    border: 1px solid $color--grey_400;
    border-radius: 3rem;
    display: flex;
    flex-wrap: nowrap;
    transition: all 0.3s;

    :global(.search-input-button-cont) {
      position: relative;
      min-width: 24px;
    }

    .label-input-search {
      display: none;
    }
    &.focus {
      border-color: black;
      border-width:3px;
    }
    button {
      display: flex;
      align-items: center;
    }
    .field {
      width: 100%;
      border: none;
      height: 2.5rem;
      outline: none;
      padding-left: 1rem;
      // font-size: 1rem;
      &:focus {
        border: none;
        outline: none;
      }
    }    
  }

  .search-status{
    position: absolute;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(0 0 99.9% 99.9%);
    overflow: hidden;
    height: 1px;
    width: 1px;
    padding: 0;
    border: 0;
  }
}

@media screen and (min-width: 768px) {
  .form-searcher {
    display: flex;
    min-width: 16rem;
    .SearchInput {
      max-width: 90%;
    }
  }
}

@media screen and (min-width: 1024px) {
  .form-searcher {
    .SearchInput {
      max-width: unset;
    }
  }
}
@media screen and (min-width: 1280px) {
  .form-searcher {
    .SearchInput {
      padding: 0rem 1rem;
      max-width: 90%;
      .field {
        height: 3rem;
        // font-size: 1rem;
      }
    }
  }
}
`}</style>
        </form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  querySuggestedInputs: state.header.querySuggestedInputs,
  pagesSuggestedList: state.header.pagesSuggestedList,
  pagesList: state.header.pagesList,
});

const mapDispatchToProps = (dispatch) => ({
  getSearcherInfo: () => dispatch(headerActions.getSearcherInfo()),
  addModal: (data) => dispatch(modalActions.addModal(data)),
  setSearcherInfo: (data) => dispatch(headerActions.setSearcherInfo(data)),
  resetSearcher: () => dispatch(headerActions.resetSearcher()),
  setRelatedPages: (data) => dispatch(headerActions.setRelatedPages(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchInput);

SearchInput.propTypes = {
  backButton: PropTypes.bool,
  placeHolder: PropTypes.string,
  autoComplete: PropTypes.string,
  needOpenModalResults: PropTypes.bool,
  autoFocus: PropTypes.bool,
  autoSetup: PropTypes.bool,
};

SearchInput.defaultProps = {
  backButton: true,
  placeHolder: "Busca en Movistar",
  autoComplete: "off",
  needOpenModalResults: false,
  autoFocus: false,
  autoSetup: false,
};
